module.exports = __webpack_public_path__ + "static/media/Arrow-left.a94c71dc.svg";